import { NgModule, SecurityContext } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '@app/src/app-routing.module';
import { AppComponent } from '@app/src/app.component';
import { HeaderComponent } from '@app/core/header/header.component';
import { NavbarComponent } from '@app/core/navbar/navbar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { CommonModule, DatePipe } from '@angular/common';
import { MaterialModule } from '@app/src/material.module';
import { AuthCallbackModule } from '@app/services/auth/auth-callback.module';
import { SharedModule } from '@app/shared/shared.module';
import { LoaderInterceptor } from '@app/interceptors/loaderInterceptor/loader.interceptor';
import { ToolsModule } from '@app/modules/tools/tools.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { GuidedTourModule, GuidedTourService } from 'ngx-guided-tour';
import { TokenInterceptorService } from '@app/src/middleware/token-interceptor.service';
import { ErrorHandlerInterceptor } from '@app/src/interceptors/errorHandler/error-handler.interceptor';
import * as enI18n from '@app/assets/i18n/en.i18n.json';
import { I18nService } from '@app/services/i18n/i18n.service';
import { i18nConfigService } from '@app/services/i18n/i18n-config.service';
import { CacheControllerInterceptor } from './interceptors/cacheIntercept/cache-controller.interceptor';
import { MarkdownModule, MarkedOptions } from 'ngx-markdown';

const languages = [
  { lang: 'EN', flag: 'assets/img/en.i18n.png', file: enI18n }
]

@NgModule({
  declarations: [
    AppComponent,
    // global
    HeaderComponent,
    NavbarComponent,


  ],
  imports: [
    MaterialModule,
    HttpClientModule,
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    MatProgressSpinnerModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    ToastrModule.forRoot({
      closeButton: true,
      progressBar: true,
      tapToDismiss: true,
      preventDuplicates: true,

    }),
    CommonModule,
    AuthCallbackModule,
    ToolsModule,
    GuidedTourModule.forRoot(),
    MarkdownModule.forRoot()
  ],

  exports: [],
  providers: [
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheControllerInterceptor,
      multi: true
    },
    GuidedTourService,
    I18nService,
    {
      provide: i18nConfigService,
      useValue: languages
    }
  ],
  bootstrap: [AppComponent],

})
export class AppModule { }
